module.exports = __webpack_public_path__ + "img/direction_icon.c0938f39.svg";